<p>
  adjust-usga-score-dialog works!
</p>
